export const STATIC_HOST = "https://static.openfoodfacts.org";
import { VERSION } from "./version.js";
export const USER_AGENT = `OpenFoodFacts - NodeJS ${VERSION}`;
/* eslint-disable no-unused-vars */
export var BackendType;
(function (BackendType) {
    BackendType["OFF"] = "OFF";
    BackendType["OBF"] = "OBF";
    BackendType["OPFF"] = "OPFF";
    BackendType["OPF"] = "OPF";
})(BackendType || (BackendType = {}));
export const BACKEND_DOMAINS = {
    [BackendType.OFF]: "openfoodfacts.org",
    [BackendType.OBF]: "openbeautyfacts.org",
    [BackendType.OPFF]: "openpetfoodfacts.org",
    [BackendType.OPF]: "openproductsfacts.org",
};
export const BACKEND_NAMES = {
    [BackendType.OFF]: "OpenFoodFacts",
    [BackendType.OBF]: "OpenBeautyFacts",
    [BackendType.OPFF]: "OpenPetFoodFacts",
    [BackendType.OPF]: "OpenProductsFacts",
};
export const DEFAULT_FOLKSONOMY_API_URL = "https://api.folksonomy.openfoodfacts.org";
export const DEFAULT_ROBOTOFF_API_URL = "https://robotoff.openfoodfacts.org/api/v1";
export const DEFAULT_NUTRIPATROL_API_URL = "https://nutripatrol.openfoodfacts.org";
export const PRODUCT_IMAGE_BASE_URL = "https://images.openfoodfacts.org/images/products";
export const PRODUCT_API_HOST = "https://world.openfoodfacts.org";
export const PRODUCT_IMAGE_URL = (path) => `${PRODUCT_IMAGE_BASE_URL}/${path}`;
//# sourceMappingURL=consts.js.map